export enum EmbedProvider {
  AOL = 'AOL',
  Facebook = 'Facebook',
  FoxNews = 'Fox News',
  Instagram = 'Instagram',
  Twitter = 'Twitter',
  YouTube = 'YouTube',
}
